var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAwQzguNTUyMjggMCA5IDAuNDQ3NzE1IDkgMVY3SDE1QzE1LjU1MjMgNyAxNiA3LjQ0NzcyIDE2IDhDMTYgOC41NTIyOCAxNS41NTIzIDkgMTUgOUg5VjE1QzkgMTUuNTUyMyA4LjU1MjI4IDE2IDggMTZDNy40NDc3MiAxNiA3IDE1LjU1MjMgNyAxNVY5SDFDMC40NDc3MTUgOSAwIDguNTUyMjggMCA4QzAgNy40NDc3MiAwLjQ0NzcxNSA3IDEgN0g3VjFDNyAwLjQ0NzcxNSA3LjQ0NzcyIDAgOCAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";